export type WorkspaceResourceStatus = 'archived' | 'locked' | 'new' | 'public' | 'template';
export type WorkspaceResourceMutableStatus = 'archived' | 'locked';

interface WorkspaceResourceStatusDefinition {
    label: string;
}

const workspaceResourceStatusDefinitions: Record<WorkspaceResourceStatus, WorkspaceResourceStatusDefinition> = {
    archived: { label: 'Archived' },
    locked: { label: 'Locked' },
    new: { label: 'New' },
    public: { label: 'Public' },
    template: { label: 'Template' },
};

export const getWorkspaceResourceStatusLabel = (status: WorkspaceResourceStatus): string =>
    workspaceResourceStatusDefinitions[status].label;

export const getWorkspaceResourceStatusActionLabel = (
    status: WorkspaceResourceMutableStatus,
    active: boolean,
): string => `${active ? 'Remove from' : 'Add to'} ${getWorkspaceResourceStatusLabel(status)}`;

export const getWorkspaceResourceStatusToggleLabel = (
    status: WorkspaceResourceMutableStatus,
    active?: boolean,
): string => {
    if (status === 'locked') {
        return active ? 'Unlock' : 'Lock';
    }

    return active ? 'Unarchive' : 'Archive';
};
